const base =  'https://test.api.process-manager.dk/';

export const environment = {
  production: false,
  redirectHost: 'https://test.app.process-manager.dk/',
  api: base + 'api/',
  base: base
};
